import React from 'react';
import { observer } from 'mobx-react-lite';
import CommonInput from '../../component/form/common-input.component';
import i18n from '../../i18n';
import riskOrderListState from './risk-order-list-state';
import { RiskOrderMode } from './risk-order-mode';

/** 即时风险列表的数据模式下拉框。 */
const RiskOrderDataModeButtons = observer(() => {
    return (
        <CommonInput
            inputType="SELECT_PILL"
            value={riskOrderListState.riskDataMode}
            items={[
                {
                    value: 'risk',
                    label: i18n.t('intelligent_risk_control_page_risk_point_mode'),
                },
                {
                    value: 'order',
                    label: i18n.t('intelligent_risk_control_page_order_mode'),
                },
            ]}
            onChange={(event) => riskOrderListState.setRiskDataMode(event.target.value as RiskOrderMode)}
        />
    );
});

export default RiskOrderDataModeButtons;
